import './styles.css';

const ChatDropdown = () => {
  return (
    <div className="gbs-chat">
      <div
        id="open-jquery-chat"
        className="gbs-chat__trigger"
        onClick={() => {
          if (window.gbsChat?.hasOwnProperty('notificationsPopup')) {
            window.gbsChat.notificationsPopup.toggle();
          }
        }}
      >
        <svg width="20" height="20" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 3.75C6.15 3.75 3.12 6.6 3.12 10c0 1.64.7 3.14 1.85 4.26.37.36.7.93.57 1.6-.07.35-.18.7-.33 1.01a4.35 4.35 0 0 0 2.3-.79c.15-.1.35-.14.52-.09.63.17 1.29.26 1.97.26 3.85 0 6.88-2.85 6.88-6.25S13.85 3.75 10 3.75ZM4.45 18.1 4 18.04a.62.62 0 0 1-.36-1.02c.33-.4.57-.88.68-1.4.01-.1-.02-.27-.22-.46A7.18 7.18 0 0 1 1.88 10c0-4.2 3.68-7.5 8.12-7.5 4.44 0 8.13 3.3 8.13 7.5s-3.7 7.5-8.13 7.5c-.7 0-1.37-.08-2.01-.23a5.6 5.6 0 0 1-3.54.83ZM5.94 10a.94.94 0 1 1 1.87 0 .94.94 0 0 1-1.87 0Zm3.12 0a.94.94 0 1 1 1.88 0 .94.94 0 0 1-1.88 0Zm3.13 0a.94.94 0 1 1 1.87 0 .94.94 0 0 1-1.87 0Z"
            fill="hsl(var(--gbs-default-200))"
          />
        </svg>
      </div>
      {!!window.gbsChatCounter && (
        <span className="gbs-chat__counter">{window.gbsChatCounter}</span>
      )}
    </div>
  );
};

export default ChatDropdown;
